import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';

// Components
import TagInput from '../../Elements/TagInput';

// Deps
import { DAY_FORMAT, ISSUE_TYPES, ORDER_STATUSES_DISPLAY } from '../../../constants';
import './OrderInfoForm.scss';

const OrderInfoForm = ({ order, types, setTypes }) => {
  return (
    <div className={`OrderInfoForm`}>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Name" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Order Ref" name="orderRef">
            <Input placeholder="Order Ref" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="deliveryDate" label="Delivery Date" rules={[{ required: true, message: 'Required' }]}>
            <DatePicker format={DAY_FORMAT} disabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="volume" label="Volume">
            <Input min={0} step={0.001} type="number" placeholder="Volume" suffix="m³" />
          </Form.Item>
        </Col>
        {order && (
          <Col span={6}>
            <Form.Item name="status" label="Status" rules={[{ required: true, message: 'Required' }]}>
              <Select
                options={Object.keys(ORDER_STATUSES_DISPLAY).map((key) => ({
                  value: key,
                  label: ORDER_STATUSES_DISPLAY[key],
                }))}
                placeholder="Order Status"
              />
            </Form.Item>
          </Col>
        )}
        <Col span={4}>
          <Form.Item name="sizeLength" label="Size (LxWxH)">
            <Input min={1} type="number" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="sizeWidth" label=" ">
            <Input min={1} type="number" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="sizeHeight" label=" ">
            <Input min={1} type="number" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="weight" label="Weight">
            <Input min={1} type="number" suffix="kg" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Support Note" name="supportNote">
            <Input.TextArea placeholder="Support Note" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="description" label="Description">
            <Input.TextArea placeholder="Description" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Issue Type" name="issueType">
            <Select
              placeholder="Select Issue Type"
              options={Object.keys(ISSUE_TYPES).map((key) => ({
                value: key,
                label: ISSUE_TYPES[key],
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Partner" name="partner">
            <Input placeholder="Partner" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Type" name="types">
            <TagInput size="normal" tags={types} onChange={(values) => setTypes(values)} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item label="Partner Contact" name="partnerContact">
            <Input placeholder="Partner Contact" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Partner Order Ref" name="partnerOrderRef">
            <Input placeholder="Partner Order Ref" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Tour Ref" name="tourRef">
            <Input placeholder="Tour Ref" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Airtable Order Record Ref" name="airtableOrderRecordRef">
            <Input placeholder="Airtable Order Record Ref" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Preparation Mode" name="preparationMode">
            <Input placeholder="Preparation Mode" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Collection Form" name="collectionForm">
            <Input placeholder="Collection Form" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default OrderInfoForm;
